// extracted by mini-css-extract-plugin
export default {"colorModeToggleSlot":"colorModeToggleSlot_KZZa","darkNavbarColorModeToggle":"darkNavbarColorModeToggle_Q0Zn"};